import React from "react"
import * as style from "./style.module.css"

const Component = ({ media, alt = "" }) => {
  // mediaが存在しない場合はnullを返す
  if (!media || !media.url) {
    return null;
  }

  return (
    <>
      {media.type === 1 ? (
        <img src={media.url} className={style.inner_media} alt={alt} />
      ) : (
        <video autoPlay muted loop playsInline className={style.inner_media}>
          <source src={media.url} />
          {/* videoタグ内にalt属性は不要です */}
        </video>
      )}
    </>
  );
};

export default Component
